// hooks
import { createDealRootSelector } from '../../offerCompareColumn/hooks/createDealRootSelector';

// libraries
import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';
import type { DealState, StateTree } from '@makemydeal/dr-dash-types';
import * as dealEffectiveSelectors from '@makemydeal/dr-dash-store/selectors/dealEffectiveSelectors';
import * as vehicleSelectors from '@makemydeal/dr-dash-store/selectors/vehicleSelectors';

// consts
import * as constants from '../../constants';

// components
import DealSummaryItem from '../common/DealSummaryItem';

// hooks
import { useDealSummary } from '../../common/DealSummaryProvider';

// styles
import { detailedViewValueStyles } from '../utils/styles';
import { useTrackedSelector } from '../../telemetry/useTrackedSelector';

const MSRP = ({ deal }: DealState) => {
    const useDealRootSelector = createDealRootSelector(deal, 'MSRP');
    const isVehicleNew = useDealRootSelector(vehicleSelectors.isVehicleNew, 'vehicleNew');
    const label = !isVehicleNew ? constants.RETAIL_PRICE : constants.MSRP;
    const retailPrice = useTrackedSelector((state: StateTree) => dealEffectiveSelectors.selectEffectiveRetailPrice(state, deal), {
        component: 'MSRP',
        field: 'effectiveRetailPrice'
    });
    const msrp = formatDollarsAndCents(retailPrice);
    const { showDetailedView } = useDealSummary();

    return <DealSummaryItem label={label} value={msrp} valueStyles={showDetailedView ? detailedViewValueStyles : {}} />;
};

export default MSRP;
